<template>
  <div class="content-page">
    <div class="bd">
      <div class="tab-content">
        <ol class="classify-list">
          <li
            v-for="item in menuList"
            :key="item.name"
            :class="menuSel == item.shopWorkerUserId ? 'active' : ''"
            @click="menuSel = item.shopWorkerUserId"
          >
            {{ item.fullName }}
          </li>
        </ol>
        <div class="option-container">
          <el-checkbox
            :indeterminate="isIndeterminate"
            v-model="checkAll"
            @change="handleCheckAllChange"
            border
            >全选</el-checkbox
          >
          <el-checkbox-group v-model="checkedAuths" @change="handleCheckedAuthsChange">
            <el-checkbox
              v-for="item in authsList"
              :label="item.type"
              :key="item.type"
              border
              >{{ item.typeName }}</el-checkbox
            >
          </el-checkbox-group>
          <el-button type="primary" @click="saveAuth">保存</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { findShopWorks, getMdcAuths, findMdcAuthsByUser, batchSetMdcAuth } from "@/api";
export default {
  data() {
    return {
      menuList: [],
      menuSel: 1,
      checkAll: false,
      checkedAuths: [],
      authsList: [],
      isIndeterminate: false,
    };
  },
  computed: {
    authsListOptions() {
      let options = [];
      this.authsList.forEach((val) => {
        options.push(val.type);
      });
      return options;
    },
  },
  watch: {
    menuSel(val) {
      this.checkedAuths = [];
      this.isIndeterminate = false;
      this.checkAll = false;
      this.findMdcAuthsByUser(val);
    },
  },
  mounted() {
    this.getPageData();
  },
  methods: {
    getPageData() {
      this.findShopWorks();
      this.getMdcAuths();
    },
    findShopWorks() {
      findShopWorks({
        isAll: 1,
      }).then((res) => {
        if (res.code == 1) {
          this.menuList = res.data;
          this.menuSel = this.menuList[0].shopWorkerUserId;
        }
        if (res.code == -1) {
          this.menuList = [];
        }
      });
    },
    getMdcAuths() {
      getMdcAuths().then((res) => {
        if (res.code == 1) {
          this.authsList = res.data;
        }
        if (res.code == -1) {
          this.authsList = [];
        }
      });
    },
    findMdcAuthsByUser(id) {
      findMdcAuthsByUser({
        workUserId: id,
      }).then((res) => {
        if (res.code == 1) {
          res.data.forEach((val) => {
            this.checkedAuths.push(val.edcAuthType);
          });
          if (res.data.length != this.authsList.length) {
            this.isIndeterminate = true;
          } else {
            this.checkAll = true;
          }
        }
        if (res.code == -1) {
        }
      });
    },
    handleCheckAllChange(val) {
      this.checkedAuths = val ? this.authsListOptions : [];
      this.isIndeterminate = false;
    },
    handleCheckedAuthsChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.authsList.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.authsList.length;
    },
    saveAuth() {
      console.log(this.checkedAuths);
      let authsParams = [];
      this.authsList.forEach((val) => {
        if (~this.checkedAuths.indexOf(val.type)) {
          authsParams.push({
            edcAuthType: val.type,
            isEnable: 1,
          });
        } else {
          authsParams.push({
            edcAuthType: val.type,
            isEnable: 0,
          });
        }
      });
      batchSetMdcAuth({
        workUserId: this.menuSel,
        edcAuthJson: JSON.stringify(authsParams),
      }).then((res) => {
        if (res.code == 1) {
          this.$notify({
            title: "提示",
            message: "保存成功",
            type: "success",
            duration: 2000,
          });
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "error",
            duration: 2000,
          });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.content-page {
  .bd {
    height: 100%;
  }
  .tab-content {
    height: 100%;
    .classify-list {
      width: 120px;
      height: 100%;
      background: #f8f8f8;
      font-size: 12px;
      li {
        color: #666666;
        padding-left: 20px;
        height: 50px;
        line-height: 50px;
        border-bottom: 1px solid #eeeeee;
        cursor: pointer;
        &.active {
          background: #fff;
        }
      }
    }
    .option-container {
      padding: 30px 40px;
      .el-checkbox.is-bordered + .el-checkbox.is-bordered {
        margin-left: 0;
      }
      .el-checkbox-group {
        margin: 15px 0;
      }
    }
  }
}
</style>
